exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll[data-v-750ccfce]{position:relative;z-index:100;overflow:hidden}h5[data-v-750ccfce]{font-weight:600;font-size:14px;line-height:1.36em;color:#000;text-transform:uppercase}\n", ""]);
